module.exports = __webpack_public_path__ + "img/fullscreen.5c133fda.svg";